enum ChartFormatEnum {
    percent = "percent",
    number = "number",
    currency = "currency",
    "number-compact" = "number-compact",
    text = "text"
}

export {
    ChartFormatEnum,
};
